import { useTranslation } from "react-i18next";

import { l } from "@emerson/locales/i18n";
import { SvgEmersonLogo } from "@shared/assets/logo";
import { Header } from "@shared/components/Header/Header";
import { PlatformLogo } from "@shared/components/PlatformLogo/PlatformLogo";
import { sharedRoutes } from "@shared/data/sharedRoutes";
import { useSharedGlobalConfig } from "@shared/hooks/useSharedGlobalConfig/useSharedGlobalConfig";
import { Link } from "@shared/react-router-dom/react-router-dom";

import * as styles from "./AuthHeader.styles";
interface Props {
  route?: string;
  showFromEmerson?: boolean;
}

const AuthHeader = ({ route, showFromEmerson = false }: Props) => {
  const { t } = useTranslation();
  const { isEmerson } = useSharedGlobalConfig();

  const renderEmersonEcologicsLogo = () => (
    <Link to={sharedRoutes.emerson.base}>
      <SvgEmersonLogo
        role="img"
        data-testid="emerson-logo"
        data-e2e="emerson-logo"
        aria-label={t(l.companies.EmersonEcologics)}
        css={styles.emersonLogo}
      />
    </Link>
  );

  const renderPlatformLogo = () => {
    if (isEmerson || showFromEmerson) return renderEmersonEcologicsLogo();

    return <PlatformLogo customCss={styles.svgContainer} />;
  };

  const renderLogo = () => {
    const content = (
      <div
        css={[
          styles.logoWrapper.base,
          (showFromEmerson || isEmerson) && styles.logoWrapper.fromCompanyByFullscript,
        ]}
      >
        {renderPlatformLogo()}
      </div>
    );

    if (route) {
      return (
        <Link aria-label="login" to={route}>
          {content}
        </Link>
      );
    }

    return content;
  };

  return <Header css={!!(showFromEmerson || isEmerson) && styles.header}>{renderLogo()}</Header>;
};

export { AuthHeader };
